export default [
  require('./assets/images/locations/location1.jpg'),
  require('./assets/images/locations/location2.jpg'),
  require('./assets/images/locations/location3.jpg'),
  require('./assets/images/locations/location4.jpg'),
  require('./assets/images/locations/location5.jpg'),
  require('./assets/images/locations/location6.jpg'),
  require('./assets/images/locations/location7.jpg'),
  require('./assets/images/locations/location8.jpg'),
  require('./assets/images/locations/location9.jpg'),
  require('./assets/images/locations/location10.jpg'),
  require('./assets/images/locations/location11.jpg'),
  require('./assets/images/locations/location12.jpg'),
  require('./assets/images/locations/location13.jpg'),
  require('./assets/images/locations/location14.jpg'),
  require('./assets/images/locations/location15.jpg'),
  require('./assets/images/locations/location16.jpg'),
  require('./assets/images/locations/location17.jpg'),
  require('./assets/images/locations/location18.jpg'),
  require('./assets/images/locations/location19.jpg'),
  require('./assets/images/locations/location20.jpg'),
  require('./assets/images/locations/location21.jpg'),
  require('./assets/images/locations/location22.jpg')
];
